import { Injectable } from "@angular/core";
import { idField, ReferenceField } from "@common/references/reference-field";
import { Resident } from "./residents.interfaces";
import { DefaultService } from "@common/references/default.service";
import urlJoin from "url-join";
import { environment } from "@environments/environment";
import {
  ResidentFormComponent
} from '@modules/universal-billing/residents/resident-form/resident-form.component';
import {
  ResidentProfileComponent
} from '@modules/universal-billing/residents/resident-profile/resident-profile.component';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { PageResult } from '@shared/components/classes/page-result';

@Injectable({
  providedIn: "root",
})
export class ResidentsService extends DefaultService<Resident> {
  backendName = 'residents';
  formComponent = ResidentFormComponent;
  formViewComponent = ResidentProfileComponent;
  formModalOptions: NgbModalOptions = {
    size: "lg",
  }
  title = 'MENU.RESIDENTS';
  titleSingular = '';
  fields: ReferenceField[] = [
    {fieldName: 'code', label: 'RESIDENTS.CODE', iconClass: 'las la-hashtag', filter: true},
    {fieldName: 'firstName', label: 'RESIDENTS.FIRST_NAME', iconClass: 'las la-user', filter: true},
    {fieldName: 'lastName', label: 'RESIDENTS.LAST_NAME', iconClass: 'las la-user', filter: true},
    {fieldName: 'middleName', label: 'RESIDENTS.MIDDLE_NAME', iconClass: 'las la-user', filter: true},
    {fieldName: 'birthDate', label: 'RESIDENTS.BIRTH_DATE', iconClass: 'las la-calendar', filter: true},
    // { fieldName: 'idCardNumber', label: 'RESIDENTS.ID_CARD_NUMBER', iconClass: 'las la-id-card' },
    // { fieldName: 'socialStatus', label: 'RESIDENTS.SOCIAL_STATUS', iconClass: 'las la-users' },
    // { fieldName: 'taxCode', label: 'RESIDENTS.TAX_CODE', iconClass: 'las la-file-alt' },
    // { fieldName: 'bankAccount', label: 'RESIDENTS.BANK_ACCOUNT', iconClass: 'las la-university' },
    // { fieldName: 'bankCode', label: 'RESIDENTS.BANK_CODE', iconClass: 'las la-key' },
    // { fieldName: 'bankAccountValid', label: 'RESIDENTS.BANK_ACCOUNT_VALID', iconClass: 'las la-check-circle' },
    // { fieldName: 'bankAccountConfirmation', label: 'RESIDENTS.BANK_ACCOUNT_CONFIRMATION', iconClass: 'las la-shield-alt' },
    // { fieldName: 'stateId', label: 'RESIDENTS.STATE', iconClass: 'las la-flag' },
    // { fieldName: 'apartmentId', label: 'RESIDENTS.APARTMENT', iconClass: 'las la-building' },
    {fieldName: 'rentType', label: 'RESIDENTS.RENT_TYPE', iconClass: 'las la-home', filter: true},
    {fieldName: 'email', label: 'RESIDENTS.EMAIL', iconClass: 'las la-envelope', filter: true},
    {fieldName: 'phoneNumber', label: 'RESIDENTS.PHONE_NUMBER', iconClass: 'las la-phone', filter: true},
    {fieldName: 'status', label: 'RESIDENTS.STATUS', viewType: 'status', iconClass: 'las la-toggle-on', filter: { type: "boolean" }}
  ];

  hasActions = true;
  hasAdd = true;
  hasDelete = true;

  getUrl(): string {
    return urlJoin(environment.apiUrl, 'residents');
  }

  assignResident(data: any) {
    return this._http.post(urlJoin(environment.apiUrl, 'apartment-assign-resident'), data)
  }
  withdraw(data: any) {
    return this._http.post(urlJoin(environment.apiUrl, 'apartment-withdraw-resident'), data)
  }
  getNoApartmentResidents(params: any = {}): Observable<PageResult<Resident>> {
    return super.getAll({ ...params , apartmentId: null });
  }
}
